// extracted by mini-css-extract-plugin
export default {"root":"Version_root__Nimxe"};